export const RESEND_COOL_DOWN = 20;
